"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import API from "@ym-framework/api-utils";
import _ from "lodash";
import Question from "@/components/Question.vue";
let ShopPlatforms = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialogController = new UiDialogController();
    this.ebusiness_data = {
      active: "all",
      tabs: [],
      plates: null,
      website: null
    };
    this.plates_data = {
      active: "",
      list: []
    };
    this.platform_list = {
      loading: false,
      list: []
    };
    this.tableLoading = false;
    this.umpty_data = false;
    this.plate_info = null;
    this.searchData = "";
    this.SearchName = _.debounce((data) => __async(this, null, function* () {
      this.ebusiness_data.plates = null;
      yield this.getListByType(this.ebusiness_data.active, data);
    }), 500);
  }
  open() {
    return __async(this, null, function* () {
      this.tableLoading = true;
      this.dialogController.visible = true;
      yield this.prepareData();
      this.tableLoading = false;
    });
  }
  prepareData() {
    return __async(this, null, function* () {
      if (this._addView) {
        let ebusiness_tabs = yield API.get(`api://base.auth/api/v7/ebusiness_types_list`, {
          params: {
            scene: "ext_ebusiness"
          }
        });
        this.ebusiness_data.tabs = [
          {
            code: "all",
            name: this.$t("shopplatforms.all")
          },
          ...ebusiness_tabs.data.datas
        ];
      } else {
        let ebusiness_tabs = yield API.get(`api://base.auth/api/v7/ebusiness_types_list`);
        this.ebusiness_data.tabs = [
          {
            code: "all",
            name: this.$t("shopplatforms.all")
          },
          ...ebusiness_tabs.data.datas
        ];
      }
      this.ebusiness_data.tabs = _.filter(this.ebusiness_data.tabs, (item) => {
        return item.code !== "Custom";
      });
      this.ebusiness_data.active = this.ebusiness_data.tabs[0].code;
      if (this._selectedIds.method === "edit") {
        if (this._selectedTypes === "IndependentSite") {
          this.ebusiness_data.active = this._selectedTypes;
          if (this._selectedIds.plate === null) {
            this.ebusiness_data.plates = null;
            yield this.getListByType(this._selectedTypes);
            return;
          }
          yield this.getListByType(this._selectedTypes);
          this.ebusiness_data.plates = this._selectedIds.plate;
          yield this.getPlatformsList(this.ebusiness_data.plates);
          this.ebusiness_data.website = this._selectedIds.web;
          return;
        }
        yield this.getListByType(this.ebusiness_data.active);
        this.ebusiness_data.tabs = _.filter(this.ebusiness_data.tabs, (item) => {
          return item.code != "Custom";
        });
        if (this._selectedIds.plate === null) {
          if (this._selectedTypes === null || this._selectedTypes === void 0) {
            this.ebusiness_data.active = this.ebusiness_data.tabs[0].code;
          } else {
            this.ebusiness_data.active = this._selectedTypes;
          }
          this.ebusiness_data.plates = null;
          yield this.getListByType(this._selectedTypes);
          return;
        }
        this.ebusiness_data.plates = this._selectedIds.plate;
        yield this.getPlatformsList(this.ebusiness_data.plates);
        this.ebusiness_data.website = this._selectedIds.web;
      }
      if (this._selectedIds.method === "payment") {
        this.ebusiness_data.tabs = _.filter(this.ebusiness_data.tabs, (item) => {
          return item.code !== "Custom";
        });
        this.ebusiness_data.active = this._selectedTypes;
        this.ebusiness_data.plates = null;
        yield this.getListByType(this._selectedTypes);
      }
      if (this._selectedIds.method === "create") {
        if (this._selectedTypes === null || this._selectedTypes === void 0) {
          this.ebusiness_data.active = this.ebusiness_data.tabs[0].code;
        } else {
          this.ebusiness_data.active = this._selectedTypes;
        }
        this.ebusiness_data.plates = null;
        yield this.getListByType(this.ebusiness_data.active);
      }
      this.dialogController.visible = true;
    });
  }
  plateChange(tabValue) {
    return __async(this, null, function* () {
      this.$emit("changeplate", tabValue.name);
      this.ebusiness_data.plates = null;
      yield this.getListByType(tabValue.name, this.searchData);
    });
  }
  getListByType(type, search) {
    return __async(this, null, function* () {
      let ebusiness_plate = null;
      if (type === "all") {
        if (this._addView) {
          let tabs_without_all = _.filter(this.ebusiness_data.tabs, (item) => {
            return item.code !== "all";
          });
          let filter_arr = _.map(tabs_without_all, "code");
          if (search) {
            let _data = `nameCN==%${search}%`;
            if (this.$i18n.locale === "zh-CN") {
              _data = `nameCN==%${search}%`;
            } else {
              _data = `nameEN==%${search}%`;
            }
            ebusiness_plate = yield API.get("api://base.auth/api/v7/ebusinesses/list_by_type", {
              params: {
                filter: filter_arr.join(","),
                search: _data
              }
            });
          } else {
            ebusiness_plate = yield API.get("api://base.auth/api/v7/ebusinesses/list_by_type", {
              params: {
                filter: filter_arr.join(",")
              }
            });
          }
        } else {
          if (search) {
            let _data = `nameCN==%${search}%`;
            if (this.$i18n.locale === "zh-CN") {
              _data = `nameCN==%${search}%`;
            } else {
              _data = `nameEN==%${search}%`;
            }
            ebusiness_plate = yield API.get(`api://base.auth/api/v7/ebusinesses/list_by_type`, {
              params: {
                search: _data
              }
            });
          } else {
            ebusiness_plate = yield API.get(`api://base.auth/api/v7/ebusinesses/list_by_type`);
          }
        }
      } else {
        if (search) {
          let _data = `nameCN==%${search}%`;
          if (this.$i18n.locale === "zh-CN") {
            _data = `nameCN==%${search}%`;
          } else {
            _data = `nameEN==%${search}%`;
          }
          ebusiness_plate = yield API.get(`api://base.auth/api/v7/ebusinesses/list_by_type`, {
            params: {
              type,
              search: _data
            }
          });
        } else {
          ebusiness_plate = yield API.get(`api://base.auth/api/v7/ebusinesses/list_by_type`, {
            params: {
              type
            }
          });
        }
      }
      if (ebusiness_plate.data.datas.length === 0) {
        this.umpty_data = true;
      } else {
        this.umpty_data = false;
      }
      this.plates_data.list = ebusiness_plate.data.datas;
      if (this._selectedIds.method === "edit") {
        this.plates_data.list = _.filter(ebusiness_plate.data.datas, (item) => {
          return item.code !== "CUSTOM";
        });
      }
      if (this._selectedIds.method === "payment") {
        this.plates_data.list = _.filter(ebusiness_plate.data.datas, (item) => {
          return item.code !== "CUSTOM";
        });
      }
      if (!this.ebusiness_data.plates && this.umpty_data === false) {
        this.ebusiness_data.plates = this.plates_data.list[0].guid;
        yield this.getPlatformsList(this.ebusiness_data.plates);
      }
    });
  }
  getPlatformsList(value) {
    return __async(this, null, function* () {
      this.platform_list.loading = true;
      let ebusiness_plaform_list = yield API.get(`api://base.auth/api/v7/ebusinesses/${value}/platforms_list`);
      this.platform_list.loading = false;
      this.platform_list.list = ebusiness_plaform_list.data.datas;
      this.ebusiness_data.website = this.platform_list.list[0].guid;
      let _website = _.find(this.platform_list.list, { default_selection: true });
      if (_website !== void 0) {
        this.ebusiness_data.website = _.find(this.platform_list.list, { default_selection: true }).guid;
      }
    });
  }
  success() {
    this.$emit("success");
  }
  submit() {
    let websit_info = _.find(this.platform_list.list, { guid: this.ebusiness_data.website });
    let plate_info = _.find(this.plates_data.list, { guid: this.ebusiness_data.plates });
    this.$emit("select", {
      webinfo: websit_info,
      plateinfo: plate_info
    });
    this.searchData = "";
    this.dialogController.visible = false;
  }
  close() {
    this.searchData = "";
    this.dialogController.visible = false;
  }
  hide_window() {
    this.searchData = "";
  }
};
__decorateClass([
  PropSync("selectedIds", {
    default: function() {
      return {
        method: "edit"
      };
    }
  })
], ShopPlatforms.prototype, "_selectedIds", 2);
__decorateClass([
  PropSync("selectedTypes", { type: String, default: function() {
    return "EBusiness";
  } })
], ShopPlatforms.prototype, "_selectedTypes", 2);
__decorateClass([
  PropSync("addView", { type: Boolean, default: function() {
    return false;
  } })
], ShopPlatforms.prototype, "_addView", 2);
ShopPlatforms = __decorateClass([
  Component({
    components: {
      UiDialog,
      Question
    }
  })
], ShopPlatforms);
export {
  ShopPlatforms as default
};
